
module.exports = {
  // Payslip PDF labels
  "No IC": "आईसी संख्या",
  "Employee No": "कर्मचारी संख्या",
  "Sr. No": "क्रमांक",
  "Earnings": "आय",
  "Total Earning": "कुल आय",
  "Deductions": "कटौतियाँ",
  "Tax Amount": "कर राशि",
  "Employee Deduction": "कर्मचारी कटौती",
  "Tax No": "कर संख्या",
  "EPF No": "EPF संख्या",
  "SOCSO No": "सोकसो संख्या",
  "Bank Name": "बैंक का नाम",
  "Account No": "खाता संख्या",
  "Employer Deduction": "नियोक्ता कटौती",
  "Net Salary": "शुद्ध वेतन",
  "Page": "पृष्ठ",
  "of": "/",
  "Issue Date": "जारी करने की तिथि",
  "Pay Add On": "अतिरिक्त भुगतान",
  "Unpaid days": "अवैतनिक दिन",
  "Dependant Active Spouse": "आश्रित जीवनसाथी",
  "Dependant Active Children": "आश्रित बच्चे",
  "Advanced Salary Deduction": "अग्रिम वेतन कटौती",
  "Payble": "देय",
  "Net Pay to Bank Account": "बैंक खाते में शुद्ध वेतन",
  "Actual Rate": "वास्तविक दर",
  "Others": "अन्य",
  "Come Late & Leave Early": "देर से आना और जल्दी जाना",
  "Unpaid Leave": "अवैतनिक अवकाश",
  "Payroll Period": "वेतन अवधि",
  "Employee Code": "कर्मचारी कोड",
  "Joining Date": "कार्यग्रहण तिथि",
  "Foreign Name": "विदेशी नाम",
  "Employee Name": "कर्मचारी का नाम",
  "Basic Rate": "मूल दर",
  "Units": "इकाइयाँ",
  "Total Earnings": "कुल आय",
  "Total Deductions": "कुल कटौतियाँ",
  "Net Pay": "शुद्ध वेतन",
  "Dept": "विभाग",
  "Pay Period": "वेतन अवधि",
  "Income Tax": "आयकर",
  "Annual Leave Taken": "ली गई वार्षिक छुट्टी",
  "Sick Leave Taken": "ली गई बीमारी छुट्टी",
  "EPF No.": "EPF सं.",
  "Tax No.": "कर सं.",
  "SOCSO No.": "सोकसो सं.",
  "Bank No.": "बैंक खाता सं.",
  "Current Month": "चालू माह",
  "Emp'ee": "कर्मचारी",
  "Emp'er": "नियोक्ता",
  "Year-To-Date": "वर्ष में अब तक",
  "Non Income Loan": "गैर-आय ऋण",
  "Salary Adjustment": "वेतन समायोजन",
  "Basic Salary": "मूल वेतन",
  "Provident Fund": "भविष्य निधि",
  "Professional Tax": "व्यवसाय कर",
  "Employer": "नियोक्ता",
  "Gratuity Provision": "ग्रेच्युटी प्रावधान",
  "Salary Slip": "वेतन पर्ची",
  "Working Days": "कार्य दिवस",
  "Date of Join": "कार्यग्रहण तिथि",
  "PAN No.": "पैन सं.",
  "PF UAN No.": "पीएफ यूएएन सं.",
  "ESI No.": "ESI सं.",
  "Bank A/C No.": "बैंक खाता सं.",
  "Earnings & Deductions": "आय और कटौतियाँ",
  "Gross Earnings": "सकल आय",
  "Net Pay (Take Home)": "शुद्ध वेतन (हाथ में)",
  "Leave Balance": "शेष छुट्टी",
  "Annual Taken": "वार्षिक ली गई",
  "Sick Taken": "बीमारी ली गई",
  "Payment Details": "भुगतान विवरण",
  "PF UAN": "पीएफ यूएएन",
  "Bank A/C": "बैंक खाता",
  "Statutory Summary": "वैधानिक सारांश",
  "Employer contributions (PF, ESI, Gratuity) are informational and not deducted from salary.": "नियोक्ता अंशदान (PF, ESI, ग्रेच्युटी) केवल जानकारी के लिए हैं और वेतन से नहीं काटे जाते।",
  "Computer Generated - No Signature Required": "कंप्यूटर जनित - हस्ताक्षर आवश्यक नहीं",
  "Payslip figures are not available for this employee.": "इस कर्मचारी के लिए वेतन पर्ची के आँकड़े उपलब्ध नहीं हैं।",
  "Employee Details": "कर्मचारी विवरण",
  "ABA Account": "एबीए खाता",
  "Salary Tax Calculation": "वेतन कर गणना",
  "Gross Taxable Pay": "सकल कर योग्य वेतन",
  "Dependants": "आश्रित",
  "Dependant Deduction": "आश्रित कटौती",
  "Taxable Salary": "कर योग्य वेतन",
  "Tax Rate": "कर दर",
  "non-resident": "अनिवासी",
  "Salary Tax": "वेतन कर",
  "Other Items": "अन्य मदें",
  "Pension Scheme": "पेंशन योजना",
  "Advance Salary Deduction": "अग्रिम वेतन कटौती",
  "Loan Repayment": "ऋण चुकौती",
  "Unpaid Days": "अवैतनिक दिन",
  "Prepared By": "द्वारा तैयार",
  "Approved By": "द्वारा अनुमोदित",
  "Received By (Employee)": "प्राप्तकर्ता (कर्मचारी)",
  "This is a computer generated payslip. KHR amounts are converted at the payroll exchange rate.": "यह कंप्यूटर जनित वेतन पर्ची है। KHR राशियाँ वेतन विनिमय दर पर परिवर्तित की गई हैं।",
  "January": "जनवरी",
  "February": "फ़रवरी",
  "March": "मार्च",
  "April": "अप्रैल",
  "May": "मई",
  "June": "जून",
  "July": "जुलाई",
  "August": "अगस्त",
  "September": "सितंबर",
  "October": "अक्टूबर",
  "November": "नवंबर",
  "December": "दिसंबर",
  "Payslip for": "वेतन पर्ची",
  "ABA Number Account": "एबीए खाता संख्या",
  "Month Basic Pay": "मासिक मूल वेतन",
  "Gross Pay": "सकल वेतन",
  "Dependent Spouse": "आश्रित जीवनसाथी",
  "Dependent Children": "आश्रित बच्चे",
  "Dependent Deduction": "आश्रित कटौती",
  "Pension Scheme 2%": "पेंशन योजना 2%",
  "No.": "संख्या",
  "Salary Tax (ToS)": "वेतन कर (ToS)",

  "Yes": "हाँ",
  "Male": "पुरुष",
  "Female": "महिला",
  "Other": "अन्य",
  "Non": "Non",
  "Spouse": "जीवनसाथी",
  "Child": "बच्चा",
  "husband": "पति",
  "brother": "भाई",
  "sister": "बहन",
  "grandfather": "grandfather",
  "grandmother": "grandmother",
  "grandson": "grandson",
  "granddaughter": "granddaughter",
  "uncle": "uncle",
  "aunt": "aunt",
  "nephew": "nephew",
  "niece": "niece",
  "cousin": "cousin",
  "friend": "मित्र",
  "Monthly": "मासिक",
  "Yearly": "वार्षिक",
  "Security": "सुरक्षा",
  "and": "और",
  "Sub": "Sub",
  "Admin": "व्यवस्थापक",
  "Comment": "टिप्पणी",
  "Description": "विवरण",
  "See": "देखें",
  "Make": "बनाएँ",
  "ON": "ON",
  "Amount": "राशि",
  "Added": "जोड़ा गया",
  "Successfully": "सफलतापूर्वक",
  "Updated": "अपडेट किया गया",
  "Your": "आपका",
  "Form": "फ़ॉर्म",
  "form": "form",
  "is": "is",
  "submitted": "submitted",
  "Manage": "प्रबंधित करें",
  "marked": "marked",
  "with": "with",
  "are": "are",
  "required": "आवश्यक",
  // "Monthly":"ប្រចាំខែ",
  "Hourly": "प्रति घंटा",
  "Weekly": "साप्ताहिक",
  "OK": "ठीक है",
  "Complaint": "शिकायत",
  "From": "से",
  "Subject": "विषय",
  "Category": "श्रेणी",
  "Number of Days Outstanding": "Number of Days Outstanding",
  "Open": "खोलें",
  "Are you sure?": "क्या आप सुनिश्चित हैं?",
  "that you want to delete this record?": "क्या आप इस रिकॉर्ड को हटाना चाहते हैं?",
  "Deleted": "हटा दिया गया",

  "View": "देखें",
  "Against": "Against",
  "Uploaded": "अपलोड किया गया",
  "Taken": "Taken",
  "Attendance": "उपस्थिति",
  "In-Time": "प्रवेश समय",
  "Out-Time": "निकास समय",
  "Total": "कुल",
  "Work": "कार्य",
  "Time": "समय",
  "Break": "विराम",
  "Are you sure that you want to edit this record which done by hr admin?": "क्या आप HR ADMIN द्वारा किए गए इस रिकॉर्ड को संपादित करना चाहते हैं?",
  "Are you sure that you want to edit this record which done by employee login?": "क्या आप कर्मचारी लॉगिन द्वारा किए गए इस रिकॉर्ड को संपादित करना चाहते हैं?",
  "Deleted Successfully": "Deleted Successfully",
  "Archived": "संग्रहीत",
  "Check In Radius Check": "Check In Radius Check",
  "Check Out Radius Check": "Check Out Radius Check",
  "Done By HR ADMIN": "Done By HR ADMIN",
  "Write reason of delete:": "Write reason of delete:",
  //"Are you sure?":"តើអ្នកប្រាកដទេ?",
  "Are you sure that you want to delete this record?": "Are you sure that you want to delete this record?",
  "ADD": "जोड़ें",
  "Hrs": "घंटे",
  "Min": "मिनट",
  "Enter Rest Time as Hrs:Min": "Enter Rest Time as Hrs:Min",
  "Enter Early Leaving as Hrs:Min": "Enter Early Leaving as Hrs:Min",
  "Please enter In time": "कृपया प्रवेश समय दर्ज करें",
  "Please enter Out time": "कृपया निकास समय दर्ज करें",
  "Can not Add Attendance": "उपस्थिति नहीं जोड़ सकते",
  "YYYY-MM-DD": "YYYY-MM-DD",
  "All fields marked with * are required": "* से चिह्नित सभी फ़ील्ड आवश्यक हैं",
  "Positions": "Positions",
  "Departments": "Departments",
  "Actual": "Actual",
  "Reason": "Reason",
  "Can not Add Privilege": "Can not Add Privilege",
  "Can not Edit Privilege": "Can not Edit Privilege",
  "Can not Delete Privilege": "Can not Delete Privilege",
  "Pending": "लंबित",
  "Approved": "स्वीकृत",
  "Rejected": "अस्वीकृत",
  "Please": "कृपया",
  //"Add":"បន្ថែម",
  "Check Your Leave Bank": "Check Your Leave Bank",
  "From Date should not be greater than To Date": "आरंभ तिथि समाप्ति तिथि से बड़ी नहीं होनी चाहिए",
  //"Check Your Leave Bank":"ពិនិត្យសមតុល្យវត្តមានរបស់អ្នក",
  "Please add leave templete for this employee ": "Please add leave templete for this employee ",
  "Leave present at this date": "Leave present at this date",
  "can": "can",
  "not": "not",
  "Start": "आरंभ",
  "End": "समाप्त",
  "Duration": "अवधि",
  "Starts in first half": "Starts in first half",
  "Starts in second half": "Starts in second half",
  "Full Day Leave": "Full Day Leave",
  "Post Edit Remark": "Post Edit Remark",
  "Attachment": "संलग्नक",
  "Staff": "स्टाफ",
  "Staffs": "Staffs",
  "Exists": "Exists",
  "Not": "Not",
  "Found": "Found",
  "Any": "Any",
  "App": "App",
  "URL": "URL",
  "Go to App Url": "Go to App Url",
  "Created At": "Created At",
  "Announcement": "Announcement",
  "Announcements": "Announcements",
  "Success": "Success",
  "Available": "Available",
  "Model": "Model",
  "Asset": "Asset",
  "Assigned": "Assigned",
  "Issue On": "Issue On",
  "Sr": "Sr",
  "Please Start the camera": "Please Start the camera",
  "Please add the image": "Please add the image",
  "Your last Checked out": "Your last Checked out",

  "Bulk Import Failed": "Bulk Import Failed",
  "in": "in",
  "Sample": "Sample",
  "CSV": "CSV",
  "File": "File",
  "Upload": "Upload",
  "You must set location allow": "You must set location allow",
  "Check Inout": "Check Inout",
  "Submit": "Submit",
  "Retry": "Retry",
  "You already Checked In": "You already Checked In",
  "Check In": "Check In",
  "Check Out": "Check Out",
  "Latitude": "Latitude",
  "Longitude": "Longitude",
  "List": "List",
  "Employees": "कर्मचारी",
  "Dashboard": "डैशबोर्ड",
  "Select": "चुनें",
  "Organization": "संगठन",
  "Status": "स्थिति",
  "Department": "विभाग",
  "Position": "पद",
  "Export": "निर्यात",
  "Import": "आयात",
  "Update": "अपडेट करें",
  "Qrcode": "Qrcode",
  "Search": "खोजें",
  "No": "नहीं",
  "New": "नया",
  "Complaints": "Complaints",
  "Information": "जानकारी",
  "Employee": "कर्मचारी",
  "Email": "ईमेल",
  "Mobile": "मोबाइल",
  "Action": "कार्रवाई",
  "Add": "जोड़ें",
  "Edit": "संपादित करें",
  "Basic": "मूल",
  "Info": "जानकारी",
  "Leaves": "अवकाश",
  "Points": "अंक",
  "Documents": "दस्तावेज़",
  "Assets": "संपत्तियाँ",
  "Salary": "वेतन",
  "Note": "नोट",
  "Payslips": "Payslips",
  "Emergency": "आपातकालीन",
  "Contacts": "संपर्क",
  "First": "First",
  "Name": "नाम",
  "ID": "आईडी",
  "Last": "Last",
  "Middle": "Middle",
  "Address": "पता",
  "Gender": "लिंग",
  "Date": "तारीख",
  "Of": "Of",
  "Birth": "जन्म",
  "Timezone": "समय क्षेत्र",
  "Location": "स्थान",
  "Long": "Long",
  "Lat": "Lat",
  "Restrict": "Restrict",
  "CheckIn": "CheckIn",
  "Radius": "Radius",
  "CheckOut": "CheckOut",
  "Nationality": "राष्ट्रीयता",
  "Resident": "निवासी",
  "Shift": "शिफ्ट",
  "Group": "समूह",
  "JD": "JD",
  "Title": "शीर्षक",
  "Access": "पहुँच",
  "UserType": "UserType",
  "QR": "QR",
  "Download": "डाउनलोड",
  "Cancel": "रद्द करें",
  "Enter": "दर्ज करें",
  "Password": "पासवर्ड",
  "In-Active": "निष्क्रिय",
  "Dependent": "Dependent",
  "Relation": "संबंध",
  "Present": "Present",
  "Age": "आयु",
  "Save": "सहेजें",
  "changes": "changes",
  "Leave": "अवकाश",
  "Template": "टेम्पलेट",
  "Current": "वर्तमान",
  "Balance": "बैलेंस",
  "Allowed": "अनुमत",
  "Negative": "ऋणात्मक",
  "Transaction": "लेन-देन",
  "History": "इतिहास",
  "Manual": "Manual",
  "Credit": "क्रेडिट",
  "Debit": "डेबिट",
  "Close": "बंद करें",
  "Frequency": "आवृत्ति",
  "Quantity": "मात्रा",
  "Paycode": "Paycode",
  "Type": "प्रकार",
  "Opening": "Opening",
  "All": "सभी",
  "Document": "दस्तावेज़",
  "Days": "दिन",
  "to": "से",
  "Already": "पहले से",
  "Expired": "समाप्त",
  "Expiry": "समाप्ति",
  "Remark": "टिप्पणी",
  "Declaration": "घोषणा",
  "Issue": "समस्या",
  "Return": "वापस",
  "Allowance": "भत्ता",
  "Code": "कोड",
  "Taxable": "कर योग्य",
  "tax": "कर",
  "Telephone": "टेलीफोन",
  "Distance": "दूरी",
  "Check out details are Not Available": "Check out details are Not Available",
  "Details": "विवरण",
  "Get": "प्राप्त करें",
  "Image": "छवि",
  "This entry is generated by Admin": "This entry is generated by Admin",
  "for": "for",
  "CheckInOut": "CheckInOut",
  "enter": "enter",
  "Email ID": "Email ID",
  "password": "password",
  "Incorrect": "Incorrect",
  "Credentials": "Credentials",
  "Login": "लॉगिन",
  "Unsuccessful": "Unsuccessful",
  "Forgot": "भूल गए",
  "Sign Up Now": "अभी साइन अप करें",
  "Sign in": "साइन इन",
  "Banner": "Banner",
  "Size": "आकार",
  "Sequence": "क्रम",
  "Publish": "प्रकाशित करें",
  "Blog": "ब्लॉग",
  "Blogs": "ब्लॉग",
  "Draft": "ड्राफ्ट",
  "Unpublished": "अप्रकाशित",
  "Published": "प्रकाशित",
  "type": "type",
  "Video": "वीडियो",
  "Back to": "Back to",
  "Chapters": "अध्याय",
  // "Chapters":"ជំពូក",
  "Chapter": "अध्याय",
  "Topics": "विषय",
  "Under this": "Under this",
  "Course": "कोर्स",
  "PDF": "PDF",
  "VIDEO": "VIDEO",
  "Topic": "विषय",
  "Involved": "Involved",
  "By": "By",
  "Welcome back": "वापसी पर स्वागत है",
  "Data": "डेटा",
  "For": "For",
  "From Date": "आरंभ तिथि",
  "To Date": "समाप्ति तिथि",
  "TODAY'S": "TODAY'S",
  "ATTENDANCE": "ATTENDANCE",
  "THIS": "THIS",
  "MONTH": "MONTH",
  "LEAVE": "LEAVE",
  "TOTAL": "TOTAL",
  "ORGANIZATIONS": "ORGANIZATIONS",
  "ACTIVE": "ACTIVE",
  "EMPLOYEES": "EMPLOYEES",
  "Today's": "Today's",
  "Project Head": "प्रोजेक्ट प्रमुख",
  "Contact No": "संपर्क नंबर",
  "Add More": "और जोड़ें",
  "Guest": "अतिथि",
  "Visit To": "Visit To",
  "License Plate": "License Plate",
  "Add Checkout Time": "Add Checkout Time",
  "Business Visit": "Business Visit",
  "Meeting": "बैठक",
  "Personal Visit": "Personal Visit",
  "Interview": "साक्षात्कार",
  "Presentation": "प्रस्तुति",
  "Sales Visit": "Sales Visit",
  "Client Visit": "Client Visit",
  "Supplier Visit": "Supplier Visit",
  //"Other":"ផ្សេងៗ",
  "Take": "Take",
  "HR": "मानव संसाधन",
  "Email Already Exists": "ईमेल पहले से मौजूद है",
  "HR Code Already Exists": "HR कोड पहले से मौजूद है",
  "Account Name Already Exists": "खाता नाम पहले से मौजूद है",
  "Account Name should not be greater than 10 characters": "Account Name should not be greater than 10 characters",
  "Database not found with given account name, Please create database first": "दिए गए खाता नाम वाला डेटाबेस नहीं मिला। कृपया पहले डेटाबेस बनाएँ",
  "Database not available to create HR admin": "HR व्यवस्थापक बनाने के लिए डेटाबेस उपलब्ध नहीं है",
  "Min.Amount": "Min.Amount",
  "Max.Amount": "Max.Amount",
  "Base amount": "Base amount",
  "Percentage": "प्रतिशत",
  "Tax": "कर",
  "Dependence Allowance": "Dependence Allowance",
  "Tax Bracket List": "Tax Bracket List",
  "Tax Bracket": "Tax Bracket",
  "Super User": "सुपर यूज़र",
  "Day": "दिन",
  "Monday": "सोमवार",
  "Rest-Time": "Rest-Time",
  "tuesday": "मंगलवार",
  "Wednesday": "बुधवार",
  "Thursday": "गुरुवार",
  "Friday": "शुक्रवार",
  "Saturday": "शनिवार",
  "Sunday": "रविवार",
  "Signup": "साइन अप",
  "Requests": "अनुरोध",
  "Reference": "संदर्भ",
  "Account": "खाता",
  "Personal": "व्यक्तिगत",
  "Create": "बनाएँ",
  "user Roles": "user Roles",
  "Task": "कार्य",
  "In Progress": "प्रगति पर",
  "Completed": "पूर्ण",
  "Logs Present in this Task so cant be deleted": "Logs Present in this Task so cant be deleted",
  "Log Text": "Log Text",
  "Logs": "Logs",
  "Projects": "प्रोजेक्ट",
  "Member": "सदस्य",
  "Moderate": "Moderate",
  "Low": "कम",
  "High": "उच्च",
  "Very High": "बहुत उच्च",
  "Priority": "प्राथमिकता",
  "Visit": "Visit",
  "Weight": "भार",
  "Value": "मान",
  "Score": "स्कोर",
  "Completion": "पूर्णता",
  "Uploaded image has not valid Height and Width": "अपलोड की गई छवि की ऊँचाई और चौड़ाई मान्य नहीं है",
  "Promotion": "पदोन्नति",
  "Redirect": "Redirect",
  "Task Presnt in this Project so cant be deleted": "Task Presnt in this Project so cant be deleted",
  "Now": "अभी",
  "Importance": "महत्व",
  "Performance Kpi": "Performance Kpi",
  "Please add the reason of delete": "कृपया हटाने का कारण जोड़ें",
  "Role": "भूमिका",
  "Please select at least one module": "कृपया कम से कम एक मॉड्यूल चुनें",
  "Analyst": "Analyst",
  "analytics": "analytics",
  "Top Selling": "Top Selling",
  "Shop": "Shop",
  "Cart": "Cart",
  "File size less than 1 MB": "फ़ाइल का आकार 1 MB से कम होना चाहिए",
  "Check Discount Price": "Check Discount Price",
  "Required": "आवश्यक",
  "Investigating": "Investigating",
  "Incident": "घटना",
  "Job": "नौकरी",
  "Level": "स्तर",
  "Grade": "ग्रेड",
  "Attach": "Attach",
  "Functions": "Functions",
  "Qualification": "योग्यता",
  "Responsibilities": "जिम्मेदारियाँ",
  "Reporting": "Reporting",
  "Perks": "Perks",
  "Benefits": "लाभ",
  "Make-Model": "Make-Model",
  "Check IN/OUT": "Check IN/OUT",
  "Please Upload the File": "Please Upload the File",
  "No mid month": "No mid month",
  "Mid Month": "Mid Month",
  "Payroll": "पेरोल",
  "Process": "प्रक्रिया",
  "Bonus": "बोनस",
  "Working": "कार्यरत",
  "Test": "परीक्षण",
  "Live": "Live",
  "Line": "Line",
  "Entry": "Entry",
  "Currency": "मुद्रा",
  "Rate": "दर",

  "Banners": "Banners",
  "Orders": "ऑर्डर",
  "Product": "उत्पाद",
  "Pay Codes": "Pay Codes",
  "Comments": "टिप्पणियाँ",
  "Career": "करियर",
  "Profile": "प्रोफ़ाइल",
  "Employee Presence": "Employee Presence",
  "Employee Absence": "Employee Absence",
  "My Job Description": "My Job Description",
  "Job Description": "Job Description",
  "Settings": "सेटिंग्स",
  "Public Holidays": "सार्वजनिक अवकाश",
  "Master Department": "Master Department",
  "Point Declaration": "Point Declaration",
  "User Role": "User Role",
  "Admin Apps": "Admin Apps",
  "Groups": "समूह",
  "Employee Bulk Import": "Employee Bulk Import",
  "Guests": "Guests",
  "Check In Out": "Check In Out",
  "Incident Report": "Incident Report",
  "Tasks": "Tasks",
  "Work Plan": "Work Plan",
  "My": "My",
  "Promotions": "Promotions",
  "Payroll Line Entry": "Payroll Line Entry",
  "Employee Chat": "Employee Chat",
  "Messages": "संदेश",
  "Training": "प्रशिक्षण",
  "SignUp Requests": "SignUp Requests",
  "My Profile": "मेरी प्रोफ़ाइल",
  "Employee Career": "Employee Career",
  "Job Post": "जॉब पोस्ट",
  "Application List": "आवेदन सूची",
  "Job Frontend Url": "Job Frontend Url",
  "Manage Shifts": "शिफ्ट प्रबंधित करें",
  "Shift Scheduler": "शिफ्ट शेड्यूलर",
  "Shift Scheduler History": "Shift Scheduler History",
  "Shift Schedule": "Shift Schedule",
  "Constants": "Constants",
  "No Preference": "No Preference",
  "Fresher": "Fresher",
  "Year": "वर्ष",
  "Short Description": "संक्षिप्त विवरण",
  "Long Description": "विस्तृत विवरण",
  "Add Thumbnail Image": "Add Thumbnail Image",
  "Enter Valid link": "Enter Valid link",
  "In Stock": "स्टॉक में",
  "Out Of Stock": "स्टॉक में नहीं",
  "In Active": "In Active",
  "Ordered": "ऑर्डर किया गया",
  "Accepted": "स्वीकृत",
  "Rejected and Closed": "अस्वीकृत और बंद",
  "Shipped/InTransit": "Shipped/InTransit",
  "Completed and Closed": "पूर्ण और बंद",
  "Cancelled and Closed": "रद्द और बंद",
  "Order No": "ऑर्डर नंबर",
  "Order On": "Order On",
  "Product Feature": "Product Feature",
  "Subtotal": "उप-योग",
  "No items in the cart": "No items in the cart",
  "Place Order": "ऑर्डर करें",
  "Change": "Change",
  // "Select":"ជ្រើសរើស",
  "Language": "भाषा",

  ////////////////////
  "Job Title": "जॉब शीर्षक",
  "All Employee": "All Employee",
  "Day Leave": "Day Leave",
  "System Logs": "सिस्टम लॉग",
  "Employee Documents": "कर्मचारी दस्तावेज़",
  "Leave Types": "अवकाश प्रकार",
  "Allowance Type": "भत्ता प्रकार",
  "Allowance Code": "Allowance Code",
  "Note Code": "Note Code",
  "Document Code": "Document Code",
  "Comment Category": "Comment Category",
  "Comment Type": "Comment Type",


  "My Shift Schedule": "My Shift Schedule",
  "My Orders": "My Orders",
  "Organization Blogs": "Organization Blogs",
  "My Attendance": "My Attendance",
  "My Leaves": "My Leaves",
  "Access Code": "Access Code",
  "My Points": "My Points",
  "My Documents": "My Documents",
  "My Assests": "My Assests",
  "My Payslips": "My Payslips",
  "Sub Admin": "Sub Admin",
  "Manage Tax Brackets": "Manage Tax Brackets",
  "All Shifts": "All Shifts",
  "Shift Scheduler Import": "Shift Scheduler Import",
  "Project Task": "Project Task",
  "Employee Training": "Employee Training",
  "Employee Shop": "Employee Shop",
  "Product Category": "उत्पाद श्रेणी",
  "Products": "उत्पाद",
  "Public Holiday": "सार्वजनिक अवकाश",
  "Blog Type": "Blog Type",
  "Job Type": "जॉब प्रकार",
  "Course Type": "कोर्स प्रकार",
  "Annoucement Type": "Annoucement Type",


  "Add/Subtract": "Add/Subtract",
  "Mood": "मूड",
  "Negative Balance": "Negative Balance",
  "Leave Bank Report": "Leave Bank Report",
  "Payroll Type": "Payroll Type",
  "Flat Salary": "Flat Salary",
  "Salary Attendance": "Salary Attendance",
  "Salary Attendance + OT": "Salary Attendance + OT",
  "Hourly Wages": "Hourly Wages",
  "Deduction": "कटौती",
  "Adjustment": "समायोजन",
  "Settlements": "Settlements",
  "Current Balance": "वर्तमान बैलेंस",
  "Allowed Negative Balance": "Allowed Negative Balance",
  "No Record Found": "कोई रिकॉर्ड नहीं मिला",
  //"Work Schedular":"Work Schedular",



  ////////Date 23/2/2kl
  "Upcoming": "आगामी",
  //"Today's":"Today's",
  "Absent": "अनुपस्थित",
  "Apply": "लागू करें",
  "Database Host": "Database Host",
  "Database User": "Database User",
  "Database Password": "Database Password",
  "Primary Database Name": "Primary Database Name",
  "Payroll Database Name": "Payroll Database Name",
  "Language Translation Type": "Language Translation Type",
  "Google Transaltor": "Google Transaltor",
  "Custom": "कस्टम",
  "Default Language": "डिफ़ॉल्ट भाषा",
  "English": "अंग्रेज़ी",
  "Khemer": "Khemer",
  "Chinese": "चीनी",
  "More than 1 organization cannot be added": "1 से अधिक संगठन नहीं जोड़ा जा सकता",
  "Organization Code already exists": "संगठन कोड पहले से मौजूद है",
  "Add Payslip Header or Footer or organization logo": "Add Payslip Header or Footer or organization logo",
  "Company Policy": "कंपनी नीति",
  "Employee Handbook": "कर्मचारी पुस्तिका",
  "Payslip Header": "Payslip Header",
  "Payslip Footer": "Payslip Footer",
  "Color Code": "Color Code",
  // "Sequence":"Sequence",

  /****29 march */

  'Shifts': "Shifts",
  "Visitor": "Visitor",
  "Work Scheduler": "Work Scheduler",
  "Work Scheduler History": "Work Scheduler History",
  "Work Scheduler Import": "Work Scheduler Import",
  "Vehicle": "वाहन",
  "Total IN Visitor": "Total IN Visitor",



  /////////Date 28/4/23/////////
  "Seniority Pay": "वरिष्ठता वेतन",
  "Convert to USD Dollar": "Convert to USD Dollar",
  //"":"",
  //'Absent':'Absent',

  "Expire With In Days": "Expire With In Days",
  //"My Profile": "我的简历",
  "Sign out": "साइन आउट",
  "Outstanding": "Outstanding",
  "Leave Bank": "अवकाश बैंक",

  "Settlement Import": "Settlement Import",
  "Tax Code": "कर कोड",
  "Business Promotions": "Business Promotions",
  "HR Blog": "HR Blog",
  "Job Discloursere": "Job Discloursere",

  "Payroll Headers": "Payroll Headers",
  "Settlement Type": "Settlement Type",
  "Settlement Code": "Settlement Code",
  "Document Types": "दस्तावेज़ प्रकार",
  "Employee Groups": "कर्मचारी समूह",

  "Job ID": "Job ID",
  "Payroll Privilege": "Payroll Privilege",
  "To": "To",
  // "Outstanding": "杰出的",
  // "Mood": "情绪",
  "options": "विकल्प",
  "General": "सामान्य",
  "Very Sad": "Very Sad",

  "Sad": "उदास",
  "Just OK": "Just OK",
  "Good": "अच्छा",
  "Fantastic": "शानदार",
  "zone": "zone",
  "Rest": "आराम",

  "NOTE:In Time and Out Time in 24 Hrs Format": "नोट: प्रवेश समय और निकास समय 24 घंटे के प्रारूप में होना चाहिए",
  //"Please select a date":"Please select a date",
  //"Rest":"Rest",
  "Early Out": "जल्दी निकास",
  "Over Time": "ओवरटाइम",
  "Late In": "देर से प्रवेश",
  "Previous": "पिछला",

  "Records": "रिकॉर्ड",
  "Check IN Out Records": "Check IN Out Records",
  "Check IN": "चेक-इन",
  "Check": "Check",
  // "Title":"Title",
  //"Address":"Address",
  "Owner": "मालिक",

  "Address Line": "Address Line",
  "City": "शहर",
  "State/Province": "राज्य/प्रांत",
  "Country": "देश",
  "Attendance Radius (in Meters)": "Attendance Radius (in Meters)",
  // "Company Policy": "Company Policy",
  // "Employee Handbook": "Employee Handbook",
  // "Payslip Header": "Payslip Header",
  // "Payslip Footer": "Payslip Footer",
  "Height": "ऊँचाई",
  "Width": "चौड़ाई",

  "ID Template": "ID Template",
  "Logo": "लोगो",
  "Active": "सक्रिय",
  "Approved/In-Active": "Approved/In-Active",
  "Write reason of": "Write reason of",
  "Are you sure that you want to In-Active this record?": "Are you sure that you want to In-Active this record?",
  "Profile Image": "प्रोफ़ाइल छवि",

  "Notice Pay": "नोटिस पे",
  "Local Name": "स्थानीय नाम",
  "expire": "expire",
  "Settlement": "निपटान",
  "NOTE: In Time and Out Time in 24 Hrs Format": "NOTE: In Time and Out Time in 24 Hrs Format",
  "Tuesday": "मंगलवार",

  "Pay Code": "Pay Code",
  "Scheduler": "शेड्यूलर",
  "Calender View": "Calender View",
  "Download Sample File": "Download Sample File",
  "Download Sample CSV File": "Download Sample CSV File",
  "Preview Of Shift Scheduler Table": "Preview Of Shift Scheduler Table",
  "Shift Scheduler of Parent Table": "Shift Scheduler of Parent Table",

  "Preview": "पूर्वावलोकन",
  // "Half":"一半",
  "Full Month": "पूरा महीना",
  "System": "सिस्टम",
  "Approval": "अनुमोदन",
  "Payslip": "वेतन पर्ची",
  "Designation": "पदनाम",
  "Multiplier": "गुणक",
  "Project": "प्रोजेक्ट",
  "Members": "सदस्य",
  "Analytics": "विश्लेषण",
  "Payment": "भुगतान",
  "Approve": "अनुमोदित करें",

  "Hours": "घंटे",
  "Maternal": "Maternal",
  "Adjustment": "समायोजन",
  "OT": "OT",
  "Paycodes": "पे कोड",
  //"Days": "天",
  "Left": "Left",

  "Joining": "ज्वाइनिंग",
  "Hiring": "नियुक्ति",
  "Application": "आवेदन",
  "Emergancy": "Emergancy",
  "Contact": "संपर्क",
  "Print": "प्रिंट",
  "Not Consider In Payroll": "Not Consider In Payroll",
  "Sequence No": "Sequence No",
  "Special": "विशेष",
  "Report": "रिपोर्ट",
  "Summary": "सारांश",
  "Out": "बाहर",
  "Link": "लिंक",
  "Url": "URL",
   "CV": "CV",
  "LinkedIn": "LinkedIn",
  "Final": "अंतिम",
  "Open Payslips": "Open Payslips",
  "Close Payslips": "Close Payslips",
  "Reports": "रिपोर्ट्स",
  "Payroll Reports": "पेरोल रिपोर्ट्स",
  "Notice Pay Reports": "Notice Pay Reports",
  "Staff IN OUT Reports": "Staff IN OUT Reports",
  "Leave Reports": "अवकाश रिपोर्ट्स",
  "Paid": "भुगतान किया गया",
  "Bank": "बैंक",
"Evaluated": "मूल्यांकन किया गया",
 'Obtained': "प्राप्त",
 "OneTime": "एक बार",
 "Daily": "दैनिक",
 "HH:MM": "HH:MM",
 "Base Amount": "मूल राशि",
 "Month": "महीना",
 "Date Range": "तिथि सीमा",
 "Staffing": "स्टाफिंग",
 "Requirement": "आवश्यकता",
 "Anyalsis": "Anyalsis",
 "Privious": "Privious",
 "Budget": "बजट",
 "To Hire": "To Hire",
 //"Work Plan":"工作计划",
 "Work Plan/KPI": "Work Plan/KPI",
"KPI": "KPI",
"Employee Evalution": "कर्मचारी मूल्यांकन",
"KPI Project": "KPI प्रोजेक्ट",
"Detail": "विवरण",
"Complete": "पूर्ण करें",
//"value":"",
"Performance": "प्रदर्शन",
"Achieved": "प्राप्त किया गया",
"Improvement": "सुधार",
"Core": "मुख्य",
"Job Disclosure": "Job Disclosure",
"Post": "पोस्ट",
"Employee List": "कर्मचारी सूची",
"Notice Pay Check": "Notice Pay Check",
"My Work Schedule": "My Work Schedule",
"Employee ID": "कर्मचारी आईडी",
"QR Code": "QR कोड",
"IDCard": "आईडी कार्ड",
"Record Added Successfully": "रिकॉर्ड सफलतापूर्वक जोड़ा गया",
"Record Updated Successfully": "रिकॉर्ड सफलतापूर्वक अपडेट किया गया",
"Can not Add the Record": "रिकॉर्ड नहीं जोड़ सकते",
"Account Code -Debit": "Account Code -Debit",
"Account Code - Credit": "Account Code - Credit",
"Pension": "पेंशन",
"Locked": "लॉक किया गया",
"Show": "दिखाएँ",
"Saas Code": "Saas Code",
"Font Color": "Font Color",
"Font Style": "Font Style",
"Hexa Code Color Background": "Hexa Code Color Background",
"normal": "normal",
"italic": "italic",
"oblique": "oblique",
"Reserved": "Reserved",
"Error": "त्रुटि",
"mom": "माँ",
"dad": "पिता",

  // //"Documents":"Documents",កូដ Saas
  // "Expired":"Expired",
  // "in":"in",
  // "days":"days",
  // "New":"New",
  // "Complaints":"Complaints",
  // "No":"नहीं",
  // "Messages":"Messages",
  // "Arrived":"Arrived",
  // "Leaves":"Leaves",
  // "today":"today",
  // "My Profile":"My Profile",
  // "Sign out":"Sign out",
  // "Flat Salary":"Flat Salary",
  // "Salary Attendance":"Salary Attendance",
  // "OT":"OT",
  // "Hourly Wages":"Hourly Wages",
  // "NOTE:In Time and Out Time in 24 Hrs Format":"NOTE:In Time and Out Time in 24 Hrs Format",
  // "Please select a date":"Please select a date",
  // "Rest":"Rest",
  // "Early Leaving":"Early Leaving",
  // "Over Time":"Over Time",
  // "Time Late":"Time Late",
  // "Previous":"Previous",
  // "Records":"Records",
  // "Check IN Out Records":"Check IN Out Records",
  // "Check IN":"Check IN",
  // "Select Status":"Select Status",
  // "ADD":"ADD",
  // "Export":"Export",
  // "Active":"Active",
  // "Title":"Title",
  // "Address":"Address",
  // "Owner":"Owner",
  // "Status":"Status",
  // "Action":"Action",
  // "Photo":"Photo",
  // "Select":"Select",
  // "User":"User",
  // "Employee Local Name":"Employee Local Name",
  // "Vehicle":"Vehicle",
  // "Notice Pay":"Notice Pay",
  // "See":"See",
  // "Not found":"Not found",
  // "Upcoming":"Upcoming",
  // "Absent":"Absent",
  // "Expire With in Days":"Expire With in Days",
  // "Leave Bank":"Leave Bank",
  // "To":"To",
  // "Outstanding":"Outstanding",
  // "Mood":"Mood",
  // "No options":"No options",
  // "General":"General",
  // "Very Sad":"Very Sad",
  // "Sad":"Sad",
  // "Just OK":"Just OK",
  // "Good":"Good",
  // "Fantastic":"Fantastic",
  // "Document Type List":"Document Type List",
  // "Dashboard":"Dashboard",
  // "Doc Type":"Doc Type",
  // "All":"All",
  // "Expiry By":"Expiry By",
  // "Days to expire";"Days to expire",
  // "All Expiry Type":"All Expiry Type",
  // "Days to expire":"Days to expire",
  // "Already Expired":"Already Expired",
  // "All Document Type":"All Document Type",
  // "In-Active":"In-Active",
  // "Select Department":"Select Department",
  // "Select Employee":"Select Employee",
  // "Work Schedular":"Work Schedular",
  // "Work Schedular History":"Work Schedular History",
  // "Work Schedular Import":"Work Schedular Import",
  // "Calender View":"Calender View",
  // "Choose File":"Choose File",
  // "No file chosen":"No file chosen",
  // "Download Sample File":"Download Sample File",
  // "Download Sample CSV File":"Download Sample CSV File",
  // "Upload":"Upload",
  // "Preview Of Shift Scheduler Table":"Preview Of Shift Scheduler Table",
  // "Shift Schduler of Parent Table":"Shift Schduler of Parent Table",
  // "All Organization":"All Organization",
  // "Test Payroll":"Test Payroll",
  // "Rate":"Rate",
  // "View":"View",
  // "Payslip":"Payslip",
  // "All Payroll Entry":"All Payroll Entry",
  // "Payroll Title":"Payroll Title",
  // "Employee ID":"Employee ID",
  // "Employee Name":"Employee Name",
  // "Department":"Department",
  // "Designation":"Designation",
  // "Color Code":"Color Code",
  // "Multiplier":"Multiplier",
  // "Pay Code":"Pay Code",
  // "Taxcode":"Taxcode",
  // "Project":"Project",
  // "In Progress":"In Progress",
  // "Closed":"Closed",
  // "Project ID":"Project ID",
  // "Status":"Status",
  // "Open":"Open",
  // "Id":"Id",
  // "Job Title":"Job Title",
  // "Job ID":"Job ID",
  // "Description":"Description",
  // "Close Date":"Close Date",
  // "No Of Candidates Applied":"No Of Candidates Applied",
  // "Number Of":"Number Of",
  // "Url":"Url",
  // "Normal":"Normal",
  // "Document Uploaded":"Document Uploaded",
  // "Public Jobs":"Public Jobs",
  // "Private Jobs":"Private Jobs",
  // "Course List":"Course List",
  // "Course":"Course",
  // "Select Course Type":"Select Course Type",
  // "Departments":"Departments",
  // "Description":"Description",
  // "Cancel":"Cancel",
  // "Chat":"Chat",
  // "Select Department":"Select Department",
  // "Select Organization":"Select Organization",
  // "Load All":"Load All",
  // "SKU":"SKU",
  // "Cost":"Cost",
  // "Price":"Price",
  // "Discount Price":"Discount Price",
  // "Link":"Link",
  // "Brand":"Brand",
  // "Top List":"Top List",
  // "Image Size":"Image Size",
  // "Documents Uploaded":"Documents Uploaded",
  // "Select Status":"Select Status",
  // "No":"नहीं",
  // "View resume":"View resume",
  // "Applied For":"Applied For",
  // "Applicant":"Applicant",
  // "Application Name":"Application Name",
  // "Applicant Mobile":"Applicant Mobile",
  // "Applicant Email":"Applicant Email",
  // "Status":"Status",
  // "Remark":"Remark",
  // "Thumbnail":"Thumbnail",
  // "Business Promotion":"Business Promotion",
  // "Visitor":"Visitor",
  // "Total IN Visitor":"Total IN Visitor",
  // "QR Code":"QR Code",
  // "Phone":"Phone",
  // "Send QR Code":"Send QR Code",
  // "Not Checked Out":"Not Checked Out",
  // "History":"History",
  // "Open":"Open",
  // "Reported":"Reported",
  // "Created On":"Created On",
  // "Incident From":"Incident From",
  // "Incident Title":"Incident Title",
  // "Incident Form":"Incident Form",
  // "Level":"Level",
  // "Remark":"Remark",
  // "Status":"Status",
  // "Description of incident":"Description of incident",
  // "Check In":"Check In",
  // "code":"code",
  // "Address Line 1":"Address Line 1",
  // "City":"City",
  // "State/Province":"State/Province",
  // "Country":"Country",
  // "Attendance Radius (In Meters)":"Attendance Radius (In Meters)",
  // "Company Policy":"Company Policy",
  // "Employee Handbook":"Employee Handbook",
  // "Payslip Header":"Payslip Header",
  // "Payslip Footer":"Payslip Footer",
  // "Height":"Height",
  // "Width":"Width",
  // "ID Template":"ID Template",
  // "Select Organization Logo":"Select Organization Logo",
  // "Public Holiday":"Public Holiday",
  // "Holiday":"Holiday",
  // "Apply Shift Schduler":"Apply Shift Schduler",
  // "Pay":"Pay",
  // "Name":"Name",
  // "Shifts":"Shifts",
  // "Pay":"Pay",
  // "Negative Balance":"Negative Balance",
  // "This field is invalid":"This field is invalid",
  // "Leave Type":"Leave Type",
  // "Admin app":"Admin app",
  // "URL":"URL",
  // "Asset":"Asset",
  // "Allowance Code":"Allowance Code",
  // "Description":"Description",
  // "Cancel":"Cancel",
  // "Add":"Add",
  // "Document Type":"Document Type",
  // "Employee Group":"Employee Group",
  // "Job ID":"Job ID",
  // "Annoucement":"Annoucement",
  // "Course Type":"Course Type",
  // "System Logs":"System Logs",
  // "User":"User",
  // "User IP":"User IP",
  // "Location":"Location",
  // "Operation":"Operation",
  // "Affected Table":"Affected Table",
  // "Rows":"Rows",
  // "Timestamp":"Timestamp",




  ////Date 20/6/23
  "Point": "Point",
 "Add Payslip Header,Footer,organization logo,ID Template": "Add Payslip Header,Footer,organization logo,ID Template",








///Date 12-06-24////////////////////
"Add on Note": "Add on Note",
"Workplan Evaluation": "Workplan Evaluation",
"Hr Letters": "Hr Letters",
"Letter ": "Letter ",
"HR Admin Payroll Processes": "HR Admin Payroll Processes",
"Payroll Line Entry Record": "Payroll Line Entry Record",
"Closed Payroll Line Entry": "Closed Payroll Line Entry",
"Cancelled Payroll Line Entry": "Cancelled Payroll Line Entry",
"Employee Monthly Target": "Employee Monthly Target",
"Employee Log Activity": "Employee Log Activity",
"Employee Summary Target Activity": "Employee Summary Target Activity",
"Dependant Import": "Dependant Import",
"Leave Import": "Leave Import",
"Assets Import": "Assets Import",
"Salary Import": "Salary Import",
"KPI of completed Project": "KPI of completed Project",
"KPI Attendance Employee": "KPI Attendance Employee",
"KPI Attendance Organization": "KPI Attendance Organization",
"KPI Attendance Organization Listing": "KPI Attendance Organization Listing",
"Groups CheckIN": "Groups CheckIN",
"Groups Attendance Logs": "Groups Attendance Logs",
"Project Groups": "Project Groups",
"Use this  Access Code For Office Entry": "Use this  Access Code For Office Entry",
"Workplan": "Workplan",
"Goal": "लक्ष्य",
"Recommendations": "सिफारिशें",
"Feedback": "प्रतिक्रिया",
"HR Actions": "HR कार्रवाइयाँ",
"Links": "Links",
"Target": "लक्ष्य",
"Activity": "गतिविधि",
"Evolution": "Evolution",
"Overtime": "ओवरटाइम",
"Employee Overtime Request": "Employee Overtime Request",
"Attendance Import": "उपस्थिति आयात",
"Exchange Rate": "विनिमय दर",
 "Cost": "लागत",
 "Closed": "बंद",
 "this": "this",
"OFF": "OFF",
"No Shows": "कोई उपस्थिति नहीं",
"No Shows": "कोई उपस्थिति नहीं",
"Total Performance": "कुल प्रदर्शन",
"Applicant": "आवेदक",
"Resume": "रिज़्यूमे",
"Close Date": "बंद करने की तारीख",
"Job Id": "जॉब आईडी",
"No Of Candidates Applied": "No Of Candidates Applied",
"Number Of": "Number Of",
"Minimum": "Minimum",
"Experience": "Experience",
"Load": "Load",
"Send": "Send",
"Price": "Price",
"Discounted": "Discounted",
"SKU": "SKU",
"Brand": "Brand",
"Top List": "Top List",
"Order": "Order",
"For e.g.": "For e.g.",
"HR Letters": "HR Letters",
"HR Letter Fields": "HR Letter Fields",





"IN": "IN",
"OUT": "OUT",
"Appointment": "Appointment",
"Valid": "Valid",
"CheckIN": "CheckIN",
"Reported": "Reported",
"Created On": "Created On",
"Media": "Media",
"Photo": "Photo",
"Holiday": "Holiday",
"Head": "Head",
"Privilege": "Privilege",
"Module": "Module",
"Delete": "Delete",
"Activity Type": "Activity Type",
"Activity Status": "Activity Status",
"Activity Valuation %": "Activity Valuation %",
"Attendance Remarks": "Attendance Remarks",
"Maximum": "Maximum",
"Valuation": "Valuation",
"Exchange": "विनिमय",
"User": "User",
"IP": "IP",
"Operation": "Operation",
"Affected": "Affected",
"Table": "Table",
"Rows": "Rows",
"Timestamp": "Timestamp",
"Payroll Process": "Payroll Process",
"Remarks": "Remarks",
"To Date": "समाप्ति तिथि",
"Only Salary": "Only Salary",
"Next": "अगला",
"Be Processed": "Be Processed",
  "Early Leaving": "Early Leaving",
  // "Over Time":"Over Time",
  "Time Late": "Time Late",
  "Done": "पूर्ण",
  "Gross": "सकल",
  "Pay": "भुगतान",
  "Unpaid": "अवैतनिक",
  "Dependant": "आश्रित",
  "Seniority": "वरिष्ठता",
  "Advanced": "अग्रिम",
  "Net": "शुद्ध",
  "Children": "बच्चे",
  "Ticket": "टिकट",



"Msg Send Successfully": "Msg Send Successfully",
"Msg Not Send Successfully": "Msg Not Send Successfully",



















  //Manage Tax Brackets             ,  
};
// }
// else
// {



// module.exports = {
//   "Employees List":
//     "Employees List",
//     "Dashboard":
//     "Dashboard",
//     "Select Organization":
//     "Select Organization",
//     "Status":
//     "Status",
//     "Select Department":
//     "Select Department",
//     "Select Positions":
//     "Select Positions",
//     "Export":
//     "Export",
//     "Import +":
//     "Import +",
//     "Update Qrcode":
//     "Update Qrcode",
//     "Search":
//     "Search",
// };

// }


